const live = 'https://api.fooddy.ng/api/v1/';
const local = 'http://localhost:4000/api/v1/';
const local2 = 'http://192.168.10.102:4000/api/v1/';
const local3 = 'http://192.168.74.105:4000/api/v1/';
export const BASE_URL = process.env.REACT_APP_API_BASE_URL || live;
